export default __webpack_public_path__ + "static/media/icon_thumbsup.5fb64031.svg";